import { useState } from 'react';
import { useExperiences } from '@/features/experiences/hooks/useExperiences';
import { useCandidateExperienceActions } from './useCandidateExperienceActions';
import type { CandidateExperienceActions } from './useCandidateExperienceActions';
import type { Experience } from '@/features/experiences/types/experience.types';

interface CandidateExperiencesResult extends CandidateExperienceActions {
  experiences: Experience[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  isCreateDialogOpen: boolean;
  setIsCreateDialogOpen: (open: boolean) => void;
  editingExperience: Experience | null;
  setEditingExperience: (experience: Experience | null) => void;
}

export function useCandidateExperiences(candidateId: string): CandidateExperiencesResult {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [editingExperience, setEditingExperience] = useState<Experience | null>(null);
  const { experiences, hasData, isLoading, isError } = useExperiences({ candidateId });
  const actions = useCandidateExperienceActions(candidateId);

  return {
    experiences,
    hasData,
    isLoading,
    isError,
    isCreateDialogOpen,
    setIsCreateDialogOpen,
    editingExperience,
    setEditingExperience,
    ...actions,
  };
}
